module.exports = __webpack_public_path__ + "bin/1f260604db7ec1b3f79d2140f9ff61f6.svg";